import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ShieldCheck, LogIn } from "lucide-react";
import { API } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("dhp_admin_token", data.access_token);
      localStorage.setItem("dhp_admin_email", data.email);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy text-white relative overflow-hidden flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="absolute inset-0 hero-grid opacity-25" />
      <div className="absolute -top-40 -right-40 h-[520px] w-[520px] rounded-full bg-[#10B981]/10 blur-[120px]" />
      <div className="absolute -bottom-40 -left-40 h-[420px] w-[420px] rounded-full bg-[#D4AF37]/10 blur-[120px]" />

      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-3 justify-center">
          <div className="h-9 w-9 rounded-md bg-white/5 flex items-center justify-center ring-1 ring-white/10">
            <ShieldCheck className="h-4 w-4 text-[#D4AF37]" />
          </div>
          <div className="leading-tight">
            <div className="font-serif text-lg">Direct Hire Payroll</div>
            <div className="eyebrow text-[10px] text-white/60">Admin Portal</div>
          </div>
        </div>

        <form onSubmit={submit} className="mt-10 bg-white/[0.03] border border-white/10 rounded-2xl p-10 backdrop-blur-sm space-y-5" data-testid="admin-login-form">
          <div>
            <h1 className="font-serif text-3xl">Sign in</h1>
            <p className="mt-2 text-sm text-white/60">Protected area — admins only.</p>
          </div>

          <div>
            <Label htmlFor="aemail" className="text-white/80">Email</Label>
            <Input id="aemail" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 bg-white/5 border-white/15 text-white placeholder:text-white/30" placeholder="admin@directhireteam.com"
              data-testid="admin-email-input" />
          </div>
          <div>
            <Label htmlFor="apw" className="text-white/80">Password</Label>
            <Input id="apw" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-white/5 border-white/15 text-white placeholder:text-white/30" placeholder="••••••••"
              data-testid="admin-password-input" />
          </div>

          <button type="submit" disabled={loading} className="btn-emerald w-full disabled:opacity-70" data-testid="admin-login-submit">
            <LogIn className="h-4 w-4" /> {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="mt-6 text-center text-xs text-white/40">
          Return to <a href="/" className="text-[#10B981] hover:underline">directhirepayroll.com</a>
        </div>
      </div>
    </div>
  );
}
